import { castToOption } from 'src/helpers';
import type { ISelectOption } from 'src/types/ISelectOption';

export enum ProductSpecificationFieldGroup {
  Pictures = 'PICTURES',
  Quantities = 'QUANTITIES',
  ProductDetails = 'PRODUCT_DETAILS',
  ShippingDetails = 'SHIPPING_DETAILS',
  SdsFiles = 'SDS_FILES',
  Condition = 'CONDITION',
  ShippingAddress = 'SHIPPING_ADDRESS',
  BillingAddress = 'BILLING_ADDRESS',
  Contacts = 'CONTACTS',
  InitialRequest = 'INITIAL_REQUEST',
  Frequency = 'FREQUENCY',
  PurchaseItems = 'PURCHASE_ITEMS',
  SalesTaxInfo = 'SALES_TAX_INFO',
}

export const PRODUCT_SPECIFICATION_FIELD_GROUP_MAPPER: Readonly<Record<ProductSpecificationFieldGroup, string>> =
  Object.freeze({
    [ProductSpecificationFieldGroup.Pictures]: 'Pictures',
    [ProductSpecificationFieldGroup.Quantities]: 'Quantities',
    [ProductSpecificationFieldGroup.ProductDetails]: 'Product Details',
    [ProductSpecificationFieldGroup.ShippingDetails]: 'Shipping Details',
    [ProductSpecificationFieldGroup.SdsFiles]: 'SDS Files',
    [ProductSpecificationFieldGroup.Condition]: 'Condition',
    [ProductSpecificationFieldGroup.ShippingAddress]: 'Shipping Address',
    [ProductSpecificationFieldGroup.BillingAddress]: 'Billing Address',
    [ProductSpecificationFieldGroup.Contacts]: 'Contacts',
    [ProductSpecificationFieldGroup.InitialRequest]: 'Initial Request',
    [ProductSpecificationFieldGroup.Frequency]: 'Frequency',
    [ProductSpecificationFieldGroup.PurchaseItems]: 'Purchase Items',
    [ProductSpecificationFieldGroup.SalesTaxInfo]: 'Sales Tax Info',
  });

export const ProductSpecificationFieldGroupOptions: ISelectOption[] = castToOption(
  ProductSpecificationFieldGroup,
  PRODUCT_SPECIFICATION_FIELD_GROUP_MAPPER
);
